var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1099 341L1099 369",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1099.5,
    cy: 336.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1094.99 336.19C1094.99 332.283 1098.29 329.117 1102.36 329.117C1102.94 329.117 1103.51 329.184 1104.06 329.308C1102.74 328.48 1101.19 328 1099.52 328C1094.81 328 1091 331.806 1091 336.5C1091 341.194 1094.81 345 1099.52 345C1101.81 345 1103.89 344.093 1105.43 342.62C1104.49 343.032 1103.45 343.263 1102.36 343.263C1098.29 343.263 1094.99 340.096 1094.99 336.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1108.4 335.6L1108.37 333.146L1106.54 334.719L1104.3 334.056L1105.11 336.337L1103.77 338.381L1106.1 338.218L1107.5 340.144L1108.13 337.763L1110.34 336.909L1108.4 335.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch1);
export default __webpack_public_path__ + "static/media/church_1.6aeb66e1d5caedbcca0a0669c27adff3.svg";
export { ForwardRef as ReactComponent };